module.exports = __webpack_public_path__ + "img/img10.61fbe8dc.png";